<ion-button [class]="className"
  (click)="clickHandler()"
  [disabled]="loading || disabled">
  <ng-container *ngIf="!loading">
    <i *ngIf="iconName" class="{{iconName}} icon"></i>
    <span>{{ label }}</span>
  </ng-container>
  <ion-spinner *ngIf="loading" name="crescent"></ion-spinner>
</ion-button>
